import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';

import { Sidebar, Topbar, Footer } from './components';

import { SimplePopup } from 'components';


import { 
  logout 
} from 'redux/actions/auth';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
}));

const Main = props => {
  const { children, logout } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  const [openPopup, setOpenPopup] = useState(false);

  const handleLogout = e => {
    //history.push('/');
    //props.logout(12);
    setOpenPopup(true);
  };

  const handleClickPopupCancel = () => {
    setOpenPopup(false);
  }

  const handleClickPopupOk = () => {
    props.logout(12);
  }

  return (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}
    >
      <Topbar onSidebarOpen={handleSidebarOpen} onClickLogout={handleLogout} />
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
        isDesktop={isDesktop}
        onClickLogout={handleLogout}
      />
      <main className={classes.content}>
        {children}
        {/* <Footer /> */}
      </main>

      <SimplePopup
        title={`로그아웃 하시겠습니까?`} 
        openPopup={openPopup} 
        onClickClose={handleClickPopupCancel} 
        onClickOk={handleClickPopupOk}
      />
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

//export default Main;

export default connect(
  null,
  { logout }
)(Main);
